import { SvgAsset, type TSvgAssetProps } from '../../components/svgAsset/SvgAsset';

const Check = (props: TSvgAssetProps) => (
  <SvgAsset width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M20 6 9 17l-5-5" fill="none" stroke="rgba(0, 35, 115, 1)" strokeWidth={'2'} strokeLinecap="round" strokeLinejoin="round" />
  </SvgAsset>
);

export default Check;
